import React from "react";

function Responseshipping(props) {
    return <div className='response-shipping'>
            </div>
}

export default Responseshipping;
